var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",staticClass:"modal-video",style:(`width: ${_vm.maxWidth}px`)},[_c('div',{ref:"name",staticClass:"modal-video__name",domProps:{"innerHTML":_vm._s(_vm.data.name)}}),_vm._v(" "),_c('div',{class:[
            'modal-video__media',
            { 'modal-video__media--wide' : _vm.wide }
            ]},[_c('z-video',{ref:"video",attrs:{"muted":false,"src":_vm.data.link,"autoplay":_vm.data.autoplay,"poster":_vm.data.image.preview}})],1),_vm._v(" "),_c('div',{ref:"detail",staticClass:"modal-video__detail",domProps:{"innerHTML":_vm._s(_vm.data.detail)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }